import { navItems, contactInfo } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 pt-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 pb-14 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-macbook-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">맥픽스</span>
            </div>
            <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-background-300">
              맥북·아이맥 회로 수리 전문. 회로도 기반 정밀 진단으로 불필요한 교체 없이 원인부터
              해결합니다.
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              {[
                { icon: "ri-kakao-talk-fill", label: "카카오톡", href: contactInfo.kakaoHref },
                { icon: "ri-instagram-line", label: "인스타그램", href: "#top" },
                { icon: "ri-youtube-line", label: "유튜브", href: "#top" },
              ].map((sns) => (
                <a
                  key={sns.label}
                  href={sns.href}
                  aria-label={sns.label}
                  className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${sns.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold uppercase tracking-wider text-accent-300">
              수리 안내
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {navItems.slice(0, 4).map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="font-body text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold uppercase tracking-wider text-accent-300">
              고객 지원
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {navItems.slice(4).map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="font-body text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#top"
                  className="font-body text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  이용약관
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-bold uppercase tracking-wider text-accent-300">
              연락처
            </h4>
            <ul className="mt-5 flex flex-col gap-4">
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-fill mt-0.5 text-accent-300"></i>
                <a
                  href={contactInfo.phoneHref}
                  className="font-heading text-xl font-black text-background-50"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-300"></i>
                <span className="font-body text-sm text-background-300">{contactInfo.email}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-accent-300"></i>
                <span className="font-body text-sm leading-relaxed text-background-300">
                  {contactInfo.address}
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-accent-300"></i>
                <span className="font-body text-sm leading-relaxed text-background-300">
                  {contactInfo.hours}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-background-50/10 py-7 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-body text-xs leading-relaxed text-background-400">
            상호 맥픽스 · 대표 김태현 · 사업자등록번호 123-45-67890 · 통신판매업신고 2024-서울강남-01234
          </p>
          <p className="font-body text-xs text-background-400">
            © {year} MacFix. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}